import React from 'react';
import { Scan } from 'lucide-react';
import ProjectTemplate from './ProjectTemplate';

const Derma = () => {
  const project = {
    title: 'Yamai Derma',
    tagline: 'Computer Vision-Based Dermal Tissue Analysis',
    icon: Scan,
    color: '#EC4899',
    overview: 'Yamai Derma utilizes state-of-the-art computer vision and image recognition algorithms to analyze skin lesions and dermatological conditions. Our system assists dermatologists in early detection of skin cancer, inflammatory conditions, and other skin diseases through non-invasive imaging analysis.',
    problems: [
      {
        title: 'Late-Stage Detection',
        description: 'Skin cancers like melanoma are often detected late when treatment is more challenging and prognosis is worse.',
      },
      {
        title: 'Access to Specialists',
        description: 'Dermatologists are not always readily available, especially in rural or underserved areas.',
      },
      {
        title: 'Visual Similarity',
        description: 'Many skin conditions appear visually similar, making accurate differentiation difficult without biopsy.',
      },
      {
        title: 'Monitoring Challenges',
        description: 'Tracking changes in skin lesions over time requires consistent documentation and comparison.',
      },
    ],
    solutions: [
      'Advanced CNN-based image classification to distinguish between benign and malignant lesions',
      'Multi-class detection covering melanoma, basal cell carcinoma, squamous cell carcinoma, and common benign conditions',
      'Lesion segmentation and measurement for accurate size tracking',
      'Explainable heatmaps highlighting the specific visual features (color variation, border irregularity, asymmetry) that influenced classification',
      'Longitudinal comparison tools to monitor lesion evolution',
    ],
    technology: 'Yamai Derma is built on advanced vision transformer architectures and convolutional neural networks trained on diverse dermatological image datasets. Our explainability framework uses Grad-CAM and attention visualization to show which parts of the image contributed most to the classification, giving dermatologists confidence in the AI recommendation.',
    roadmap: [
      {
        title: 'Dataset Curation & Model Training (2026)',
        description: 'Partner with dermatology clinics to build diverse, high-quality training datasets',
      },
      {
        title: 'Clinical Validation (2027)',
        description: 'Prospective studies comparing AI performance to expert dermatologists',
      },
      {
        title: 'Mobile App Development (2028)',
        description: 'Create patient-facing app for preliminary self-screening and monitoring',
      },
      {
        title: 'Market Launch (2029)',
        description: 'Commercial release for both clinical and consumer use',
      },
    ],
  };

  return <ProjectTemplate project={project} />;
};

export default Derma;